import { render, staticRenderFns } from "./SummaryResult.vue?vue&type=template&id=e6870b98&scoped=true&"
import script from "./SummaryResult.vue?vue&type=script&lang=js&"
export * from "./SummaryResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6870b98",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/summary/SummaryResult.vue
// module id = 1552
// module chunks = 0